import yup from '../../../../config/yup';

export const copyFileToS3TaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('sftpOperation'),
  function: yup.string().default('copyFileToS3'),
  parameters: yup.object().shape({
    credentials: yup.string(),
    port: yup.string(),
    source: yup.string(),
    result: yup.string(),
    targetS3Bucket: yup.string().required('Target S3 Bucket is required'),
    awsAccessKeyId: yup.string().required('AWS Access Key ID is required'),
    awsSecretAccessKey: yup.string().required('AWS Secret Access Key is required'),
  }),
});
